<template>
    <div>
        <v-server-table ref="recognitionTable" url="/admin/recognitions-list" :columns="columns" :options="options">

            <router-link slot="recognition_id" slot-scope="props" :to="`/employees/recognitions-types/edit/${props.row.recognition_id}`" title="Edit Recognition Type" class="btn btn-sm btn-default">
                <i class="fa fa-edit"></i> Edit
            </router-link>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['recognition_id', 'recognition_name'],
                options: {
                    columnsDropdown: false,
                    filterable: false,
                    headings: {
                        recognition_id: 'Edit',
                        recognition_name: 'Recognition Name',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'recognitions.recognition_name',
                    },
                    uniqueKey: 'recognition_id',
                },
            }
        }
    }
</script>
